import { formatMomentFromNow } from 'utils/date.utils';
import BuildLevelVolcano from './BuildLevelVolcano';
import imageVolcano from 'assets/icons/Reusable/no_image.png';

export const NotificationCardVolcano = (
	{ notification, bulletin, noti, link, type, img, date, actual }
) => {

	const level = notification.properties.activityLevel || 4;
	
	const defineType = () => {
		if ( bulletin ) {
			return bulletin.name
		}
		return noti ? noti.description : '';
	}

	return (
		<a
			href = { link }
			target = "_blank"
			rel = "noopener noreferrer"
			style = {{ textDecoration: "none", color: "#646464" }}
		>
			<div className = "notification-card-volcano">
				<div className = "notification-volcano-item">
					<div className = "title-notification-volcano">
						<p className="title-type">
							{
								type === 'Noticia'
									? `Noticia - ${ noti.type }`
									: type
							}
						</p>
						<p>{ notification.properties.VolcanoName }</p>
					</div>
					<div className = "info-notification-volcano">
						{
							type === 'Noticia' ? (
								<div
									className = "intensity-notification-volcano"
									style = {{
										backgroundImage: `url(${ imageVolcano })`
									}}
								>
									{
										img === undefined && (
											<BuildLevelVolcano
												level = { level }
											/>
										)
									}
								</div>
							) : (
								<div className = "intensity-notification-volcano">
									{
										img === undefined && (
											<BuildLevelVolcano
												level = { level }
											/>
										)
									}
								</div>
							)
						}
						<div className = "level-download-volcano">
							<div className = "depth-localization">
								<div className = "container-description">
									<p style = {{ wordBreak: "break-all" }}>
										{ defineType() }
									</p>
								</div>
								<hr />
								{
									date && (
										<p>
											{ date } Hora local, { formatMomentFromNow(actual) }
										</p>
									)
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		</a>
	)
}
